import { API_BASE_URL, getAuthHeaders } from '../../utils/utils';

const jsonHeaders = () => ({
  ...getAuthHeaders(),
  'Content-Type': 'application/json',
});

export function fundingErrorMessage(data, fallback) {
  if (typeof data?.detail === 'string' && data.detail.trim()) {
    return data.detail;
  }
  if (Array.isArray(data?.detail) && data.detail.length) {
    return data.detail
      .map((row) => row.msg || row.message || '')
      .filter(Boolean)
      .join(' ');
  }
  return fallback;
}

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: options.body ? jsonHeaders() : getAuthHeaders(),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(fundingErrorMessage(data, 'Request failed'));
  }
  return data;
}

export function fetchFundingHome() {
  return request('/api/funding/home');
}

export function fetchFundingProfile() {
  return request('/api/funding/profile');
}

export function saveFundingProfile(payload) {
  return request('/api/funding/profile', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function fetchFundingSources() {
  return request('/api/funding/sources');
}

export function createFundingSource(payload) {
  return request('/api/funding/sources', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateFundingSource(sourceId, payload) {
  return request(`/api/funding/sources/${sourceId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function deleteFundingSource(sourceId) {
  return request(`/api/funding/sources/${sourceId}`, {
    method: 'DELETE',
  });
}

export function evaluateFundingSource(sourceId, payload = { reviewer: 'ai' }) {
  return request(`/api/funding/sources/${sourceId}/evaluate`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function saveFundingDocument(payload) {
  return request('/api/funding/documents', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function reviewFundingDocument(documentId, payload) {
  return request(`/api/funding/documents/${documentId}/review`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchFundingReviewers() {
  return request('/api/funding/reviewers');
}
